import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import noop from 'lodash/noop';

var useIsEllipsized = function useIsEllipsized(ref) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isEllipsized = _useState2[0],
      setIsEllipsized = _useState2[1];

  useEffect(function () {
    var element = ref.current;

    if (!element) {
      return noop;
    }

    var rafID;

    var checkIfEllipsized = function checkIfEllipsized() {
      rafID = requestAnimationFrame(function () {
        var isOverflowing = element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
        setIsEllipsized(isOverflowing);
      });
    };

    var observer = new ResizeObserver(checkIfEllipsized);
    observer.observe(element);
    return function () {
      observer.disconnect();
      cancelAnimationFrame(rafID);
    };
  }, [ref, isEllipsized]);
  return isEllipsized;
};

export { useIsEllipsized };